import { useState } from 'react';
import { Button, Confirm } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { updateContent } from 'actions/ContentActions';
import { entrySelector } from './ArchiveHeader';
import { ITypeHeaderProps } from 'components/contentTypes/CustomTypeInput';

export function ArchiveButton({ id, type }: ITypeHeaderProps) {
  const [modalVisible, setModalVisible] = useState(false);
  const entry = useSelector(entrySelector(id, type));
  const dispatch = useDispatch();

  const archived = entry?.archived === true;
  const onToggle = () => {
    if (!entry) return;

    entry.archived = !entry?.archived;
    dispatch(updateContent(entry));
  };

  return (
    <>
      <Confirm
        open={modalVisible}
        content={`Are you sure you want to ${archived ? 're-activate' : 'archive'} this item?`}
        confirmButton="Yes"
        onCancel={() => setModalVisible(false)}
        onConfirm={() => {
          onToggle();
          setModalVisible(false);
        }}
      />
      <Button
        icon
        positive={archived}
        negative={!archived}
        disabled={!entry}
        title={`${archived ? 'Re-activate' : 'Archive'} item`}
        style={{ marginLeft: 16 }}
        onClick={() => setModalVisible(true)}
      >
        <i className={`${archived ? 'check' : 'trash alternate outline'} icon`} />
      </Button>
    </>
  );
}
